import { isUsuarioUsoMuto } from 'utils';
import {
  FOLHA_PONTO_OLD,
  PEDIDO_VOO,
  CALENDARIO_FERIADOS_ADMIN,
  JORNADA,
} from 'constants/modules';
import { isRoleAuditoriaNsir } from '../../../../helpers/auditoriaNsirPermission';
import { hasModuleConfiguration } from '../../../../helpers/moduleConfigurationPermission';
import { isAdmin, INSPETOR } from 'constants/role';

/** Path do menu Folha de Ponto / Jornada. */
export const getJornadaMenuPath = (authData, moduleConfigurations) =>
  hasModuleConfiguration(moduleConfigurations, authData, JORNADA)
    ? '/v2/jornada'
    : '/v2/folha-pontos';

export const getJornadaMenuTitle = (authData, moduleConfigurations) =>
  hasModuleConfiguration(moduleConfigurations, authData, JORNADA)
    ? 'Jornada'
    : 'Folha de Ponto';

/** Match explícito — não usar includes('jornada') (colide com jornada-medicao). */
export const isJornadaMenuActive = pathname =>
  pathname === '/v2/jornada' || pathname.startsWith('/v2/jornada/');

/** Path do menu Controle de Jornada / Jornada Medição (mesma flag `JORNADA`). */
export const getJornadaMedicaoMenuPath = (authData, moduleConfigurations) =>
  hasModuleConfiguration(moduleConfigurations, authData, JORNADA)
    ? '/v2/jornada-medicao'
    : '/v2/controle-frequencia';

export const getJornadaMedicaoMenuTitle = (authData, moduleConfigurations) =>
  hasModuleConfiguration(moduleConfigurations, authData, JORNADA)
    ? 'Jornada Medição'
    : 'Controle de Jornada';

export const isJornadaMedicaoMenuActive = pathname =>
  pathname === '/v2/jornada-medicao' || pathname.startsWith('/v2/jornada-medicao/');

/**
 * Itens dinâmicos de Folha de Ponto / Jornada para o menu lateral (formato legado: href).
 */
export const renderFolhaPonto = (authData, moduleConfigurations) => {
  if (isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(authData.role)) return [];

  const options = [];

  options.push({
    title: getJornadaMenuTitle(authData, moduleConfigurations),
    href: getJornadaMenuPath(authData, moduleConfigurations),
    show: true,
    key: 'inspecao',
    isActivePath: (pathname) => {
      if (hasModuleConfiguration(moduleConfigurations, authData, JORNADA)) {
        return isJornadaMenuActive(pathname);
      }
      return pathname === '/v2/folha-pontos' || pathname.startsWith('/v2/folha-pontos/');
    },
  });

  return options;
};

/**
 * Item Controle de Jornada / Jornada Medição.
 */
export const renderControleJornada = (authData, moduleConfigurations) => {
  if (isUsuarioUsoMuto(authData.email)) return [];

  return [{
    title: getJornadaMedicaoMenuTitle(authData, moduleConfigurations),
    href: getJornadaMedicaoMenuPath(authData, moduleConfigurations),
    show: true,
    key: 'recursosHumanos',
    isActivePath: (pathname) => {
      if (hasModuleConfiguration(moduleConfigurations, authData, JORNADA)) {
        return isJornadaMedicaoMenuActive(pathname);
      }
      return pathname === '/v2/controle-frequencia'
        || pathname.startsWith('/v2/controle-frequencia/');
    },
  }];
};

export const renderPedidoVoo = (authData, moduleConfigurations) => {
  const isCustomRole = isUsuarioUsoMuto(authData.email) || isRoleAuditoriaNsir(authData.role);
  const rolePermission = isAdmin(authData.role) || authData.role === INSPETOR;

  if (isCustomRole || !rolePermission) return [];

  const options = [];
  if (hasModuleConfiguration(moduleConfigurations, authData, PEDIDO_VOO, { allowNullUserId: true })) {
    options.push({
      title: 'Pedidos de Voo',
      href: '/v2/pedidos-voo',
      show: true,
      key: 'inspecao',
    });
  }

  return options;
};

export const renderCalendarioFeriadosAdmin = (authData, moduleConfigurations) => {
  const options = [];
  if (
    hasModuleConfiguration(moduleConfigurations, authData, CALENDARIO_FERIADOS_ADMIN, {
      allowNullUserId: true,
    })
  ) {
    options.push({
      title: 'Calendário Admin. & Gestão',
      href: '/v2/calendario-admin',
      show: true,
      key: 'recursosHumanos',
    });
  }

  return options;
};
